var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"container"},[_c('span',{staticClass:"label",class:{ marked: _vm.value },domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{class:{ checkmark: true, marked: _vm.value }})])
}
var staticRenderFns = []

export { render, staticRenderFns }